import { render, staticRenderFns } from "./cmpMenu.vue?vue&type=template&id=6ba0efd4&scoped=true"
import script from "./cmpMenu.vue?vue&type=script&lang=js"
export * from "./cmpMenu.vue?vue&type=script&lang=js"
import style0 from "./cmpMenu.vue?vue&type=style&index=0&id=6ba0efd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba0efd4",
  null
  
)

export default component.exports